import type { ComponentProps } from 'react';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

import { useTrackEventEffect } from '@order/Telemetry';

import { useHasLoggedOut } from '../../../context/AuthMachine';
import { SignedOutView, SignedOutViewContent } from '../../SignedOutView';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountSignedOutMessage = (props: Props) => {
  const { isEmbedded = false, ...signedOutViewProps } = props;
  const { title, redirectTo, onJoinOrSignInaBtnPress } = signedOutViewProps;

  const hasLoggedOut = useHasLoggedOut();

  useTrackEventEffect({ name: 'account.logged_out_view', skip: hasLoggedOut });

  // A scroll view nested in the account menu's scroll view collapses, so skip it here.
  if (isEmbedded) {
    return (
      <View testID="signed-out-view" style={styles.embeddedContainer}>
        <SignedOutViewContent
          title={title}
          redirectTo={redirectTo}
          onJoinOrSignInaBtnPress={onJoinOrSignInaBtnPress}
        />
      </View>
    );
  }

  return <SignedOutView {...signedOutViewProps} />;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  embeddedContainer: {
    flexGrow: 1,
    paddingBottom: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof SignedOutView> & {
  isEmbedded?: boolean;
};
